import { TextSource } from './types';
import RAHMEN from './rahmen';
import STAMMDATEN from './stammdaten';
import HOME from './home';
import BETREUUNG24H from './betreuung24h';
import HAUSWIRTSCHAFT from './hauswirtschaft';
import KOSTEN from './kosten';
import UEBERUNS from './ueberuns';
import KARRIERE from './karriere';
import KONTAKT from './kontakt';
import AKTUELLES from './aktuelles';
import MITEINANDER from './miteinander';
import ORTSSEITEN from './ortsseiten';

/**
 * Alle Originaltexte der Website, zusammengeführt aus den Dateien je Seite.
 *
 * Beim Ergänzen einer Seite hier eintragen und in der Seite dieselben Schlüssel
 * über `<T>` bzw. `t()` verwenden. Doppelte Schlüssel gewinnt der spätere Eintrag —
 * die Präfixe je Seite (`kosten.…`) verhindern das in der Praxis.
 *
 * Nicht dabei: Impressum und Datenschutz. Ihre Texte sind Rechtstexte und bleiben
 * bewusst im Code — die Kontaktdaten darin folgen aber über `useContact()` dem,
 * was hier gepflegt wird.
 */
export const DEFAULT_TEXTS: TextSource = {
  ...RAHMEN,
  ...STAMMDATEN,
  ...HOME,
  ...BETREUUNG24H,
  ...HAUSWIRTSCHAFT,
  ...KOSTEN,
  ...UEBERUNS,
  ...KARRIERE,
  ...KONTAKT,
  ...AKTUELLES,
  ...MITEINANDER,
  ...ORTSSEITEN,
};

export * from './types';
